import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const createTicket = async (ticketRequest) => {
    try {
        const response = await client.post("/ticket", ticketRequest);
        return response.data;
    } catch (err) {
        throw new Error(err);
    }
}